import _ from 'lodash';
//constants
import { Ifield } from '../types';
import { FormControl, TextField, FormHelperText, Autocomplete } from '@mui/material';
import { getErrorText } from '..';
import { CustomTextField } from 'theme/elements/Inputs';
import { useAppSelector } from 'hooks/redux.hooks';
import { selectTranslations } from 'state/reducers/translation.reducers';

type props = {
	valid: boolean;
	cField: Ifield;
	initialValidation: any;
	handleChange: any;
};

export const SelectAutocomplete = (props: props) => {
	const t = useAppSelector(selectTranslations);
	const { valid, cField, handleChange, initialValidation } = props;
	const { name, value, label, placeholder, options } = cField.props;
	let inputValue: { value: any; label: string } | null = null;
	const extraProps: any = {};
	if (_.has(cField, 'renderOption')) {
		extraProps['renderOption'] = cField.renderOption;
	}
	if (_.has(cField, 'renderInput')) {
		extraProps['renderInput'] = cField.renderInput;
	}
	if (_.has(cField, 'getOptionDisabled')) {
		extraProps['getOptionDisabled'] = cField.getOptionDisabled;
	}
	const prepareOptions = () => {
		const list: { value: any; label: string }[] = [];
		if (options?.map) {
			options.map((option: any, idx) => {
				const val = cField.valueProperty ? option[cField.valueProperty] : option.value;
				const lab = cField.labelProperty ? option[cField.labelProperty] : option.label;
				inputValue = value === val ? { value: val, label: lab } : inputValue;
				list.push({
					...option,
					value: val,
					label: lab,
				});
			});
		}
		return list;
	};
	return (
		<CustomTextField key={name}>
			<FormControl error={!valid} fullWidth sx={cField.styleObj}>
				<Autocomplete
					options={prepareOptions()}
					value={inputValue}
					isOptionEqualToValue={(option: any, value: any) => option.value === value.value}
					onChange={(event, params: any) => {
						handleChange({ target: { value: params?.value, name: name } });
					}}
					renderInput={(params) => {
						return (
							<TextField
								{...params}
								{...cField.props}
								error={!valid}
								label={label}
								name={name}
								variant="outlined"
								placeholder={placeholder}
							/>
						);
					}}
					{...extraProps}
				/>
				<FormHelperText error={!valid}>{getErrorText(initialValidation, name)}</FormHelperText>
			</FormControl>
		</CustomTextField>
	);
};
